import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";
import {
  COMPANY_SETTING_FRAGMENT,
  CompanySettingFragment,
} from "graphql/fragment/company.setting.fragment";
import { ID } from "../../../utils/id";

interface Data {
  setting: CompanySettingFragment;
}
interface Variables {
  company: ID;
  input: {
    name: string;
    value: string;
  };
}
const MUTATION = gql`
  mutation createCompanySetting($input: CompanySettingInput!, $company: ID!) {
    setting: createCompanySetting(setting: $input, company: $company) {
      ...CompanySetting
    }
  }
  ${COMPANY_SETTING_FRAGMENT}
`;

export const useCreateCompanySettingMutation = (
  options: useMutation.Options<Data, Variables> = {},
): useMutation.ResultTuple<Data, Variables> => {
  const oldUpdate = options.update;
  options.update = (cache, result, options) => {
    cache.evict({
      fieldName: "getSettings",
    });
    cache.evict({
      fieldName: "getCompanySettingByName",
    });
    cache.gc();

    if (oldUpdate) {
      oldUpdate(cache, result, options);
    }
  };

  return useMutation<Data, Variables>(MUTATION, options);
};
